import React, { FunctionComponent } from 'react';
import { Grid } from 'semantic-ui-react';
import withStyles from 'react-jss';

import {
  MetricsByMetro,
  Type,
  TopMetros,
} from 'components/TopMetros/TopMetros.helpers';
import ReportBase, { ReportParams } from 'scenes/Report/components/ReportBase';
import { TopMetrosList, TopMetrosMap } from 'components/TopMetros';
import { Theme } from 'config';
import { ClassProp } from 'helpers/types';

const styles = (theme: Theme) => ({
  grid: {
    margin: '0 auto !important',
  },
  title: {
    color: `${theme.violet} !important`,
    width: '100% !important',
  },
  city: {
    color: '#585858 !important',
    marginBottom: '0.5rem !important',
  },
  topMetros: {
    marginTop: '1.5rem !important',
    paddingTop: '.75rem !important',
  },
  cityList: {
    display: 'flex !important',
    alignItems: 'center !important',
  },
  map: {
    display: 'flex !important',
    alignItems: 'center',
    padding: '0 !important',
  },
});

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  data: MetricsByMetro[];
  topMetros: TopMetros[];
  params: ReportParams;
  type: Type;
};

const TopMetro: FunctionComponent<Props> = ({
  classes,
  params,
  data,
  topMetros,
  type,
}) => (
  <ReportBase
    batchKey={`topMetro${type}`}
    noMargin
    header={`Top Metro ${type}`}
    params={params}
  >
    <Grid className={classes.grid}>
      <Grid.Row className={classes.topMetros}>
        <Grid.Column className={classes.cityList} width={5}>
          <TopMetrosList indicator={type} topMetros={topMetros} />
        </Grid.Column>
        <Grid.Column className={classes.map} width={11}>
          <TopMetrosMap metricsData={data} height={300} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </ReportBase>
);

export default withStyles(styles)(TopMetro);
